import { cn } from '../../../libs/utils';

import { BasicStepper } from './BasicStepper';
import { ProgressStepper } from './ProgressStepper';
import { StepperProps } from './type/Stepper.type';
import { calculateProgress } from './util/calculateProgress';

export function Stepper({ className, variant = 'step', title, maxStep = 3, currentStep = 1, progressSize = 'small' }: StepperProps) {
  if (variant === 'step' && (maxStep === undefined || currentStep === undefined)) {
    console.error('BasicStepper requires maxStep and currentStep');
  }

  return (
    <div className={cn('w-full', className)}>
      {variant === 'step' ? (
        <BasicStepper title={title} maxStep={maxStep} currentStep={currentStep} />
      ) : (
        <ProgressStepper title={title} progressValue={calculateProgress(currentStep, maxStep)} progressSize={progressSize} />
      )}
    </div>
  );
}
